import { VehicleCoveragesAndEndorsementsDiff } from '@clearcover/core-app-types';
import React from 'react';
import {
  PolicyChangeCard,
  changeTypes,
  getUnifiedDiffType,
  joinNonEmpty,
} from '../PolicyChangeCard/PolicyChangeCard';
import {
  ChangeCard,
  ChangeCardAndDetails,
  CoveragesAndEndorsementsDiff,
} from '../PolicyChangeCard/types';
import { PolicyChangeCoverageDetails } from './PolicyChangeCoverageDetails';

export const toVehicleCoverageCardAndDetails = (
  diff: VehicleCoveragesAndEndorsementsDiff,
  versionId: string,
  withLabel?: boolean
): ChangeCardAndDetails => {
  const { year, make, model, bodyStyle } = diff.metadata;
  const vehicleName = joinNonEmpty(year, make, model, bodyStyle);
  const diffType = getUnifiedDiffType([
    ...diff.coverages,
    ...diff.endorsements,
  ]);
  const title = `Coverage ${changeTypes[diffType]}`;

  return {
    card: makeCoveragesCard(vehicleName, diff),
    details: () => (
      <PolicyChangeCoverageDetails
        versionId={versionId}
        label={vehicleName}
        diff={diff}
        withLabel={withLabel}
      />
    ),
    metadata: {
      type: 'coverage',
      action: diffType,
      title,
      value: vehicleName,
    },
  };
};

export const toPolicyCoverageCardAndDetails = (
  diff: CoveragesAndEndorsementsDiff,
  versionId: string,
  withLabel?: boolean
): ChangeCardAndDetails => {
  const label = 'Policy Level';
  const diffType = getUnifiedDiffType([
    ...diff.coverages,
    ...diff.endorsements,
  ]);
  const title = `Coverage ${changeTypes[diffType]}`;

  return {
    card: makeCoveragesCard(label, diff),
    details: () => (
      <PolicyChangeCoverageDetails
        versionId={versionId}
        label={label}
        diff={diff}
        withLabel={withLabel}
      />
    ),
    metadata: {
      type: 'coverage',
      action: diffType,
      title,
      value: label,
    },
  };
};

const makeCoveragesCard =
  (
    label: string,
    { coverages, endorsements }: CoveragesAndEndorsementsDiff
  ): ChangeCard =>
  ({ 'data-testid': dataTestId, selected, onClick }) => {
    const diffType = getUnifiedDiffType([...coverages, ...endorsements]);
    return (
      <PolicyChangeCard
        data-testid={dataTestId}
        title={`Coverage ${changeTypes[diffType]}`}
        onClick={onClick}
        selected={selected}
        type="coverage"
        action={diffType}
        value={label}
      />
    );
  };
